import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { useAppSelector } from "../../../app/hooks";
import { loginRequest } from "../../../authConfig";
import { LBtn } from "../../../common/components/LBtn";
import { LSubTitle } from "../../../common/components/LSubtitle";
import { LTitle } from "../../../common/components/LTitle";
import { NavItems } from "../../../common/helpers/navigation";
import { AssessmentStatus } from "../../../common/store/generalTypes";
import { useApi } from "../../../services/useApi";
import { Colors } from "../../../styles/colors";
import { AssessmentShell } from "../components/AssessmentShell";
import { Translate } from "react-i18nify";
import type { StorageAssessmentForm } from "./assessmentWelcome";

export const AssessmentComplete = (): JSX.Element => {
    const { instance } = useMsal();
    const { updateAssessmentStatus } = useApi();
    const navigate = useNavigate();
    const assessment = useAppSelector((x) => x.assessment);
    const storageAssessmentForm = JSON.parse(
        localStorage.getItem("assessmentForm") ?? "{}"
    ) as Partial<StorageAssessmentForm>;
    const isRemoteAssessment = storageAssessmentForm.isRemote === true;

    useEffect(() => {
        if (isRemoteAssessment) {
            localStorage.setItem(
                "assessmentForm",
                JSON.stringify({
                    ...storageAssessmentForm,
                    isCompleted: true
                })
            );
        }

        const completeAssessment = async (): Promise<void> => {
            if (!assessment.locationId || !assessment.id) {
                return;
            }

            await updateAssessmentStatus(assessment.locationId, assessment.id, AssessmentStatus.Complete);
        };

        void completeAssessment();
    }, []);

    const handleOnFacilitatorLogin = async (): Promise<void> => {
        // TODO: using popup because redirect we lose the assessment id
        await instance.loginPopup({
            ...loginRequest,
            redirectUri: `${location.origin}/`
        });

        navigate(NavItems.Assessments.AssessmentReview.path);
    };

    if (isRemoteAssessment) {
        return (
            <div className="assessment-complete" style={{ backgroundColor: "#eef7fb", minHeight: "100vh" }}>
                <div
                    className="is-flex is-align-items-center is-justify-content-center"
                    style={{ backgroundColor: Colors.primaryBlue, height: "185px" }}
                >
                    <img src="/i-Function_logo-white3.png" alt="i-Function" style={{ width: "135px" }} />
                </div>
                <section
                    className="has-text-centered"
                    style={{
                        borderTop: "1px solid #1f2a2e",
                        borderBottom: "1px solid #1f2a2e",
                        padding: "22px 16px"
                    }}
                >
                    <h1 className="has-text-weight-normal" style={{ color: "#1f1f1f", fontSize: "3.25rem" }}>
                        <Translate value="assessments.remoteCompleted" />
                    </h1>
                </section>
                <p
                    className="has-text-centered"
                    style={{ color: "#1f1f1f", fontSize: "1.75rem", padding: "28px 16px" }}
                >
                    <Translate value="assessments.resultsAvailable" />
                </p>
            </div>
        );
    }

    return (
        <div style={{ backgroundColor: Colors.primaryBlue }}>
            <AssessmentShell>
                <div className="is-flex is-flex-direction-column">
                    <LTitle overrideSize="5rem" theme="dark">
                        <Translate value="assessments.completed" />
                    </LTitle>
                    <LSubTitle theme="dark">
                        <Translate value="assessments.thankYou" />
                    </LSubTitle>

                    <div className="is-flex is-justify-content-center mt-6" style={{ textAlign: "start" }}>
                        <LBtn type="button" onClick={handleOnFacilitatorLogin} theme="dark">
                            <Translate value="assessments.facilitatorLogin" />
                        </LBtn>
                    </div>
                </div>
            </AssessmentShell>
        </div>
    );
};
